module.exports = __webpack_public_path__ + "img/dci-web-features-bg-top.8b3a5cfb.png";